import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/scheme',
    name: 'Scheme',
    component: () => import('../views/scheme/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/culture',
    name: 'Culture',
    component: () => import('../views/culture/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/about/index.vue'),
    meta: {
      keepAlive: false
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  next() // 则执行next()方法 跳转到下一个页面（自己设置）
})

export default router
